<div class="w-full flex justify-center">
	<div class="max-w-[1800px] w-full">
		<zaeper-page-layout [navigation]="navigation" [pageLayout]="ePageLayout.CARDS"
							[title]="'company-management' | zDictionary">
			<ng-template zTemplate="header">
				<zaeper-icon fontSet="material-icons-outlined">business</zaeper-icon>
			</ng-template>

			<div class="flex flex-col gap-6">
				@if (activeCompany$ | async; as company) {
					<div class="flex flex-row items-center gap-4">
						<span class="text-2xl font-semibold">{{ company.name }}</span>
					</div>
					@if (company.description) {
						<p class="text-surface-600 dark:text-surface-300">{{ company.description }}</p>
					}

					<zaeper-tab-navigation [tabs]="tabs">
						<ng-template zTemplate="tab">
							<div class="flex flex-col gap-4">
								<p-table [tableStyle]="{ 'min-width': '30rem' }"
										 [value]="(members$ | async) ?? []">
									<ng-template pTemplate="header">
										<tr>
											<th>{{ 'email' | zDictionary }}</th>
											<th>
												<span class="inline-flex items-center gap-2">
													{{ 'role' | zDictionary }}
													<button type="button" class="text-sm font-normal text-primary underline-offset-2 hover:underline focus-visible:outline-2"
															(click)="isCompareRolesOpen = true">{{ 'compare-roles' | zDictionary }}</button>
												</span>
											</th>
											<th>{{ 'actions' | zDictionary }}</th>
										</tr>
									</ng-template>
									<ng-template let-member pTemplate="body">
										<tr>
											<td>{{ member.email }}</td>
											<td>
												@if (isAdmin$ | async) {
													<p-select [options]="roleOptions"
															  [ngModel]="member.role"
															  (ngModelChange)="changeRole(member.userId, $event)"
															  optionValue="value"
															  [ariaLabel]="'role' | zDictionary">
														<ng-template let-option pTemplate="selectedItem">{{ option.value | zRole }}</ng-template>
														<ng-template let-option pTemplate="item">
															<div class="flex max-w-xs flex-col whitespace-normal">
																<span>{{ option.value | zRole }}</span>
																<small class="text-surface-500 dark:text-surface-400">{{ option.value | zRole: 'description' }}</small>
															</div>
														</ng-template>
													</p-select>
												} @else {
													<p-tag [severity]="member.role === 'ADMIN' ? undefined : 'secondary'"
														   [value]="member.role | zRole" [pTooltip]="member.role | zRole: 'description'" />
												}
											</td>
											<td>
												@if (isAdmin$ | async) {
												<div class="flex gap-2 justify-end">
													<p-button (onClick)="removeMember(member.userId)"
															  icon="pi pi-trash"
															  [outlined]="true"
															  [rounded]="true"
															  severity="danger"
															  [pTooltip]="'remove' | zDictionary" />
												</div>
												}
											</td>
										</tr>
									</ng-template>
									<ng-template pTemplate="emptymessage">
										<tr>
											<td colspan="3" class="text-center text-surface-500 dark:text-surface-400 py-4">
												{{ 'no-members-available' | zDictionary }}
											</td>
										</tr>
									</ng-template>
								</p-table>
							</div>
						</ng-template>

						<ng-template zTemplate="tab">
							<div class="flex flex-col gap-4">
								@if (isAdmin$ | async) {
								@if (joinCode$ | async; as joinCode) {
									<div class="flex flex-row items-center gap-4 p-4 border border-surface-200 dark:border-surface-700 rounded-lg">
										<div class="flex flex-col gap-1 flex-1">
											<span class="text-lg font-mono font-semibold">{{ joinCode.code }}</span>
											<span class="text-sm text-surface-500 dark:text-surface-400">
												@if (isJoinCodeExpired(joinCode)) {
													{{ 'expired' | zDictionary }}
												} @else {
													{{ 'valid-until' | zDictionary }} {{ joinCode.expiresAt | date:'dd.MM.yyyy HH:mm' }}
												}
											</span>
										</div>
										<p-tag [severity]="isJoinCodeExpired(joinCode) ? 'danger' : undefined"
											   [value]="isJoinCodeExpired(joinCode) ? ('expired' | zDictionary) : ('active' | zDictionary)" />
										<p-button (onClick)="generateJoinCode()"
												  [loading]="(isLoadingJoinCode$ | async) ?? false"
												  [rounded]="true"
												  [outlined]="true"
												  icon="pi pi-refresh"
												  [pTooltip]="'generate-new-code' | zDictionary" />
									</div>
								} @else {
									<p-button (onClick)="generateJoinCode()"
											  [loading]="(isLoadingJoinCode$ | async) ?? false"
											  [rounded]="true"
											  icon="pi pi-refresh"
											  [label]="'generate-new-code' | zDictionary" />
									<p class="text-surface-500 dark:text-surface-400">{{ 'no-active-join-code' | zDictionary }}</p>
								}
								} @else {
								<p class="text-surface-500 dark:text-surface-400">{{ 'company-admins-only' | zDictionary }}</p>
								}
							</div>
						</ng-template>

						<ng-template zTemplate="tab">
							<div class="flex flex-col gap-4">
								@if (isAdmin$ | async) {
								<p-table [tableStyle]="{ 'min-width': '30rem' }"
										 [value]="(joinRequests$ | async) ?? []">
									<ng-template pTemplate="header">
										<tr>
											<th>{{ 'user-id' | zDictionary }}</th>
											<th>{{ 'status' | zDictionary }}</th>
											<th>{{ 'actions' | zDictionary }}</th>
										</tr>
									</ng-template>
									<ng-template let-request pTemplate="body">
										<tr>
											<td>{{ request.userId }}</td>
											<td>
												<p-tag [severity]="request.status === 'PENDING' ? 'warn' : request.status === 'ACCEPTED' ? 'success' : 'danger'"
													   [value]="request.status" />
											</td>
											<td>
												@if (request.status === 'PENDING') {
													<div class="flex gap-2 justify-end">
														<p-button (onClick)="acceptJoinRequest(request)"
																  icon="pi pi-check"
																  [outlined]="true"
																  [rounded]="true"
																  severity="success"
																  [pTooltip]="'accept' | zDictionary" />
														<p-button (onClick)="rejectJoinRequest(request)"
																  icon="pi pi-times"
																  [outlined]="true"
																  [rounded]="true"
																  severity="danger"
																  [pTooltip]="'reject' | zDictionary" />
													</div>
												}
											</td>
										</tr>
									</ng-template>
									<ng-template pTemplate="emptymessage">
										<tr>
											<td colspan="3" class="text-center text-surface-500 dark:text-surface-400 py-4">
												{{ 'no-join-requests-available' | zDictionary }}
											</td>
										</tr>
									</ng-template>
								</p-table>
								} @else {
								<p class="text-surface-500 dark:text-surface-400">{{ 'company-admins-only' | zDictionary }}</p>
								}
							</div>
						</ng-template>

						<ng-template zTemplate="tab">
							<div class="flex flex-col gap-4">
								@if (isAdmin$ | async) {
								<div class="flex flex-row gap-2">
									<input [(ngModel)]="inviteEmail"
										   pInputText
										   [placeholder]="'email-address' | zDictionary"
										   type="email" />
									<p-button (onClick)="sendInvitation()"
											  [disabled]="!inviteEmail.trim()"
											  [rounded]="true"
											  icon="pi pi-send"
											  [label]="'invite' | zDictionary" />
								</div>

								<p-table [tableStyle]="{ 'min-width': '30rem' }"
										 [value]="(invitations$ | async) ?? []">
									<ng-template pTemplate="header">
										<tr>
											<th>{{ 'email' | zDictionary }}</th>
											<th>{{ 'status' | zDictionary }}</th>
											<th>{{ 'valid-until' | zDictionary }}</th>
										</tr>
									</ng-template>
									<ng-template let-invitation pTemplate="body">
										<tr>
											<td>{{ invitation.email }}</td>
											<td>
												<p-tag [severity]="invitation.status === 'PENDING' ? 'warn' : invitation.status === 'ACCEPTED' ? 'success' : 'danger'"
													   [value]="invitation.status" />
											</td>
											<td>{{ invitation.expiresAt | date:'dd.MM.yyyy HH:mm' }}</td>
										</tr>
									</ng-template>
									<ng-template pTemplate="emptymessage">
										<tr>
											<td colspan="3" class="text-center text-surface-500 dark:text-surface-400 py-4">
												{{ 'no-invitations-available' | zDictionary }}
											</td>
										</tr>
									</ng-template>
								</p-table>
								} @else {
								<p class="text-surface-500 dark:text-surface-400">{{ 'company-admins-only' | zDictionary }}</p>
								}
							</div>
						</ng-template>
					</zaeper-tab-navigation>
				} @else {
					<p class="text-surface-500 dark:text-surface-400">{{ 'no-company-selected' | zDictionary }}</p>
				}
			</div>
		</zaeper-page-layout>
	</div>
</div>

<zaeper-compare-roles-dialog [(visible)]="isCompareRolesOpen" [language]="(language$ | async) ?? 'de'"
							 [productLines]="(productLines$ | async) ?? ['signage']" [role]="(activeRole$ | async) ?? null" />
